import Box from "./Box";
import MyTempSave from "./MyTempSave";
import MySaveHistory from "./MySaveHistory";
import Calling from "./Calling";
import Notice from "./Notice";
import MyReview from "./MyReview";
import { useSelector } from "react-redux";
const Main = (props, ref) => {
    const userSelector = useSelector((store) => store.user);
    const isWriter = userSelector.isWriter;
    const isReviewer = userSelector.isReviewer;
    const isExternal = userSelector.isExternal;

    const common = useSelector(store => store.common);
    const internal = common.external === "false"

    return (
        <section className={"mypage"}>
            <h3>My Page</h3>
            <div className={"d-flex mypage-container"}>
                <div>
                    <Box title={"Notice"} hide={false}>
                        <Notice />
                    </Box>
                    {(isReviewer || isExternal) && (
                        <>
                            <Box title={"My Comment"}>
                                <MyReview />
                            </Box>
                           <Box title={"Calling"}>
                                <Calling />
                            </Box>
                        </>
                    )}
                </div>
                <div>
                    {(isWriter && internal)&& (
                        <>
                            <Box title={"My Save"}>
                                <MyTempSave />
                            </Box>
                            <Box title={"Confirm History"}>
                                <MySaveHistory />
                            </Box>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Main;
